module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eTCVQ"))).then(() => parcelRequire('d0iPb'));